import { Divider, Grid } from '@mui/material'
import OtherConfigCommonFilter from './OtherConfigCommonFilter'
import { Item } from '../../../../../common/snippets'
import LineinputV2 from '../../../../../common/lineinputV2'
import { navigation3 } from '../../../../../common/helper'
import { useTranslation } from '../../../../../../i18n/I18nProvider'

const mpesaDefaultValue = {
  BranchPayBillNo: '',
  ConsumerSecretKey: '',
  Passkey: '',
  ConsumerKey: '',
}

const mpesaFields = (bum) => [
  { label: bum.branchPayBillNo || 'Branch Pay Bill No', field: 'BranchPayBillNo', id: 'mpesa_branch_pay_bill_no', md: 2, nextId: 'cancelBtn', prevId: 'mpesa_passkey' },
  { label: bum.consumerSecretKey || 'Consumer Secret Key', field: 'ConsumerSecretKey', id: 'mpesa_consumer_secret', md: 2.4, nextId: 'mpesa_passkey', prevId: 'mpesa_consumer_key' },
  { label: bum.passkey || 'Passkey', field: 'Passkey', id: 'mpesa_passkey', md: 4, nextId: 'mpesa_branch_pay_bill_no', prevId: 'mpesa_consumer_secret' },
  { label: bum.consumerKey || 'Consumer Key', field: 'ConsumerKey', id: 'mpesa_consumer_key', md: 3, nextId: 'mpesa_consumer_secret', prevId: 'goBtn' },
]

const OtherConfigMpesa = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}

  const { tabInfo } = props
  const {
    resetFlag,
    setResetFlag,
    resetAllValueBrnhMaster,
    getBranchCargoData,
    brnhOtherCargoValue,
    showBottom,
    setShowBottom,
  } = tabInfo

  const getFieldValue = (field) => brnhOtherCargoValue?.[field] ?? mpesaDefaultValue[field] ?? ''
  const fields = mpesaFields(bum)

  return (
    <>
      <OtherConfigCommonFilter
        resetAllValueBrnhMaster={() => {
          resetAllValueBrnhMaster()
          setResetFlag(!resetFlag)
        }}
        getData={getBranchCargoData}
        nextId='mpesa_consumer_key'
        setShowBottom={setShowBottom}
      />
      <Divider />
      {showBottom && (
        <Grid container sx={{ padding: '10px 8px' }} spacing={1}>
          {fields.map((item) => (
            <Grid item md={item.md} key={item.id}>
              <Item className='input--wrapper btmSpaceNotRequired'>
                <LineinputV2
                  label={item.label}
                  id={item.id}
                  value={getFieldValue(item.field)}
                  disabled={true}
                  onKeyDown={(e) => {
                    navigation3(e, item.nextId, item.prevId, () => { })
                  }}
                />
              </Item>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  )
}

export default OtherConfigMpesa
